import { ModuleType, QueryKeys } from '@/enums';
import { BannerPayLoad } from '@/interfaces/banner';
import { IBrandCustomFilters, ICustomFilter } from '@/interfaces/customFilters';
import { IKeyBannerProperty } from '@/interfaces/homepage';
import { getBrandCustomFilter, getCategoryCustomFilter, getModuleBanner } from '@/services/product.service';
import { useQuery } from '@tanstack/react-query';

export const useModuleBanner = (bannerPayload: BannerPayLoad) => {
  return useQuery<IKeyBannerProperty[]>({
    queryKey: [QueryKeys.moduleBanner + '-' + bannerPayload.seName],
    queryFn: async () => {
      return await getModuleBanner(bannerPayload);
    },

    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: false,
    enabled: !!bannerPayload.seName,
  });
};

export const useModuleCustomFilter = (module: string, seName: string, includeFeaturedImage: boolean = false) => {
  if (module === ModuleType.Category) {
    return useQuery<ICustomFilter>({
      queryKey: [QueryKeys.moduleCustomFilter + '-' + seName + '-' + module],
      queryFn: async () => {
        return await getCategoryCustomFilter(seName, includeFeaturedImage);
      },
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!seName,
    });
  } else {
    return useQuery<IBrandCustomFilters>({
      queryKey: [QueryKeys.moduleCustomFilter + '-' + seName + '-' + module],
      queryFn: async () => {
        return await getBrandCustomFilter(seName);
      },
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!seName
    });
  }
};
